interface NoteProps {
  kind?: "info" | "error" | "warning" | "success";
  children: React.ReactNode;
}

/** One line of explanation, in the colour of what it is explaining. */
export function Note({ kind = "info", children }: NoteProps) {
  return <p className={`note note--${kind}`}>{children}</p>;
}
